module.exports = __webpack_public_path__ + "ac6ca9b0abe0cc70d2b7608d5208de7a.svg";